module.exports = __webpack_public_path__ + "img/sup_vip_class_upgrading2.7620c1cd.jpg";